import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';

function utmSourceCell(visibleColumns: any) {
  if (!visibleColumns.includes('utmSource')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('UTM-Source', { ns: 'sales' })} />,
    dataIndex: ['utmSource'],
    key: 'utmSource',
    render: (utmSource: any) => <CellText>{utmSource}</CellText>,
    width: 150,
  };
}

export default utmSourceCell;
